import { UIComponentCSSStyle } from '../uicomponentcss';
import { UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { ToolbarSearchViewImpl } from './toolbarsearchview';
import { ToolbarSearchCSSStyleImpl } from './toolbarsearchcss';
import { APIModelHandler, APIModel } from '../uicomponentapimodel';
import { ToolbarSearchAPIModelImpl, ToolbarSearchAPIModel } from './toolbarsearchapimodel';
import { APIFeatures } from '../../../core/util/apifeatures';
import { RoutingFeatures } from '../../components/navigation/routingfeature';
import { DropDownDto } from '../../../core/dto/dropdown/dropdowndto';
import { CategoryDto } from '../../../core/dto/categories/categorydto';
import { LanguageConst } from '../../../utils/resources/languageconst';

export interface ToolbarSearchComponentProps extends UIComponentProps
{
    // onSearchClicked(searchKey: string): void;
    // onSignIn(): void;
    categories: CategoryDto[];
    onLogoClicked(): void;
    // onSalathiClicked(): void;
    onDoItYourselfClicked(): void;
    onMyAccountOptionClicked(routingFeature: string): void;
    onCategoriesSelected(title: string): void;
    onFaqClicked(): void;
}

export interface ToolbarSearchComponentHandler extends UIComponentHandler
{
    deselectAll(): void;
    onCategoriesSelected(title: string): void;
    onMyAccountOptionClicked(dropDownDto:DropDownDto): void;
    onMyAccountSelected(isShow: boolean): void;
    onTunesSelected(isShow: boolean): void;
    onDoItYourselfSelected(isShow: boolean): void;
    onLanguageChange(languageSelected: LanguageConst): void;
    // onSearchClicked(searchKey: string): void;
    onFaqClicked(): void;
    onSignIn(): void;
}

export interface ToolbarSearchComponentState extends UIComponentState
{
   isMyAccountSelected: boolean;
   isTunesSelected: boolean;
   isDoitYourselfSelected: boolean;
   categories: CategoryDto[];
}

export class ToolbarSearchComponent extends UIComponentImpl<ToolbarSearchComponentProps, ToolbarSearchComponentState, UIDataModel> 
implements ToolbarSearchComponentHandler
{
    private sessionTimeOut:any;
    constructor(props: ToolbarSearchComponentProps)
    {
        super(props);

        this.state = {isDoitYourselfSelected: false, isMyAccountSelected: false, categories: this.props.categories, isTunesSelected: false};
    }

    componentDidMount()
    {
        if(this.props.context.getUserContext().getIsLoggedIn())
        {
            let currentDate: number;

            this.sessionTimeOut = setInterval(() => {
                
                currentDate = Date.now();
            
                if(currentDate >= this.props.context.getUserContext().getExpiryTimeStamp())
                {
                    clearInterval(this.sessionTimeOut);
                    (this.getView() as ToolbarSearchViewImpl).showLoader();
                    (this.getAPIModel() as ToolbarSearchAPIModel).logout();
                }
                
             }, 1000);
        }
    }
    componentWillUnmount()
    {
        clearInterval(this.sessionTimeOut);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ToolbarSearchViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ToolbarSearchCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new ToolbarSearchAPIModelImpl(applicationContext, apiModelHandler);
    }

    componentWillReceiveProps(nextprops: ToolbarSearchComponentProps)
    {
        this.setState({categories: nextprops.categories});
    }

    // onSearchClicked(searchKey: string): void 
    // {
    //     this.props.onSearchClicked(searchKey);
    // }

    onSignIn(): void 
    {
        this.props.context.getRedirectionHandler().routeNextFeature(RoutingFeatures.LOGIN, false);
    }

    onLanguageChange(languageSelected: LanguageConst): void 
    {
        this.props.context.getUserContext().setLanguage(languageSelected);
        this.props.context.setUserContext(this.props.context.getUserContext());
        
        this.props.context.getRedirectionHandler().routeNextFeature(RoutingFeatures.HOME, false);
        window.location.reload();
    }


    onFaqClicked(): void
    {
        this.props.onFaqClicked();
    }

    onMyAccountOptionClicked(dropDownDto:DropDownDto): void 
    {
        console.log("-------feature: " + dropDownDto.getId());

        this.onMyAccountSelected(false);
        
        if(dropDownDto.getId() === RoutingFeatures.LOGOUT)
        {
            (this.getView() as ToolbarSearchViewImpl).showLoader();
            (this.getAPIModel() as ToolbarSearchAPIModel).logout();
        }
        else if(dropDownDto.getId() === RoutingFeatures.MENU_CATEGROIES)
        {
            this.props.context.getRedirectionHandler().routeNextFeature(this.props.context.getRoutingPath() +
            "/" + RoutingFeatures.MENU_CATEGROIES+ "?category-name=" + dropDownDto.getTitle(), false);
        }
        else
        {
            this.props.onMyAccountOptionClicked(dropDownDto.getId());
        }
    }

    deselectAll()
    {
        this.setState({isMyAccountSelected: false, isDoitYourselfSelected: false, isTunesSelected: false});
    }

    onMyAccountSelected(isShow: boolean): void 
    {
        this.setState({isMyAccountSelected: isShow, isDoitYourselfSelected: false, isTunesSelected: false});
    }

    onTunesSelected(isShow: boolean): void 
    {
        this.setState({isTunesSelected: isShow, isDoitYourselfSelected: false, isMyAccountSelected: false});
    }

    onCategoriesSelected(title: string): void 
    {
        this.props.onCategoriesSelected(title);
    }

    onDoItYourselfSelected(isShow: boolean): void 
    {
        this.setState({isDoitYourselfSelected: isShow, isTunesSelected: false, isMyAccountSelected: false});
    }

    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        if(feature === APIFeatures.LOGOUT)
        {
            (this.getView() as ToolbarSearchViewImpl).dismissLoader();
             this.props.context.logout();
            this.props.onMyAccountOptionClicked(RoutingFeatures.HOME);
        }
    }
    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        if(feature === APIFeatures.LOGOUT)
        {
            (this.getView() as ToolbarSearchViewImpl).dismissLoader();
             this.props.context.logout();
            this.props.onMyAccountOptionClicked(RoutingFeatures.HOME);
        }
        else if(feature === APIFeatures.CATEGORIES)
        {
            this.setState({categories: data as CategoryDto[]});
            // let dropDown;

            // let dtos = (data as CategoryDto[]).map((categorydto: CategoryDto) =>
            // {
            //     dropDown = new DropDownDtoImpl();
            //     dropDown.setId(RoutingFeatures.MENU_CATEGROIES);
            //     dropDown.setIconName("");
            //     dropDown.setTitle(categorydto.getTitle());

            //     return dropDown;
            // });
            // this.setState({categories: dtos});
        }
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toolbarwithsearch/toolbarsearchcomponent.tsx